const Contact = () => {
    return <h1>Kontakt Jesper </h1>;
  };
  
  export default Contact;